export default "__VITE_ASSET__Bf3m5vF$__"